import RequestProduct from './RequestProduct';

export default RequestProduct;
